import { useState } from "react";

type HookValue<Item> = {
    modalSelectionItem: Item | null;
    onModalOpen: (item: Item) => void;
    onModalClose: VoidFunction;
    onModalSubmit: (countryId: number) => void;
};

export const useExportCountryModal = <Item>(
    onSubmit: (selectionItem: Item, countryId: number) => void,
): HookValue<Item> => {
    const [modalSelectionItem, setModalSelectionItem] = useState<Item | null>(null);

    const onModalSubmit = (countryId: number): void => {
        if (modalSelectionItem === null) {
            return;
        }

        onSubmit(modalSelectionItem, countryId);
    };

    const restSelectionItem = (): void => {
        setModalSelectionItem(null);
    };

    return {
        modalSelectionItem,
        onModalOpen: setModalSelectionItem,
        onModalClose: restSelectionItem,
        onModalSubmit,
    };
};
